import type { ApprovalInfo } from '@/types/approvals'

/**
 * A Representative's approved (active) workflow goes back for approval when
 * its steps change (AB#22468). The backend decides precisely (a rename alone
 * keeps it live); these helpers only drive the builder's warning before Save
 * and the message after it.
 */

export interface ResubmitWarningInput {
  isRep: boolean
  status: string | null | undefined
  dirty: boolean
}

/** Warn before saving when the save may send a live workflow back for approval. */
export function saveNeedsResubmitWarning({ isRep, status, dirty }: ResubmitWarningInput): boolean {
  return isRep && status === 'active' && dirty
}

export interface SavedWorkflowLike {
  status?: string | null
  approval?: ApprovalInfo | null
}

/**
 * What to tell the user once a save returns. `previousStatus` is the status
 * the builder showed before the save; a flip to pending_approval means the
 * backend re-parked the workflow.
 */
export function describeSaveResult(saved: SavedWorkflowLike, previousStatus: string | null | undefined): string {
  if (saved.status === 'pending_approval' && previousStatus !== 'pending_approval') {
    const who = saved.approval?.approver_name?.trim() || 'your approver'
    return `Changes sent to ${who} for approval. The workflow stays paused until it is approved again.`
  }
  return 'Workflow saved'
}
